import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { RiRocketLine } from 'react-icons/ri';
import { MenuContent, MenuItem, MenuRoot, MenuTrigger } from '@/components/ui/menu';
import { Tooltip } from '@/components/ui/tooltip';
export type OptimizationPresetId = 'quick' | 'normal' | 'precise' | 'veryPrecise';
type OptimizationPreset = {
  id: OptimizationPresetId;
  label: string;
  maxMinutes: number;
};
export const OPTIMIZATION_TIME_BUFFER_MINUTES = 2;
const formatDuration = (minutes: number): string => {
  if (minutes < 60) {
    return `~${minutes} mins`;
  }
  const hours = Math.floor(minutes / 60);
  const remainderMinutes = minutes % 60;
  if (remainderMinutes === 0) {
    return `~${hours} hrs`;
  }
  return `~${hours} hrs ${remainderMinutes} mins`;
};
export const optimizationPresets: OptimizationPreset[] = [{
  id: 'quick',
  label: 'Quick',
  maxMinutes: 3
}, {
  id: 'normal',
  label: 'Normal',
  maxMinutes: 8
}, {
  id: 'precise',
  label: 'Precise',
  maxMinutes: 30
}, {
  id: 'veryPrecise',
  label: 'Very precise',
  maxMinutes: 120
}];
type OptimizeMenuProps = {
  isDisabled?: boolean;
  onSelectPreset: (presetId: OptimizationPresetId) => void;
  onSelectCustom: () => void;
  /**
   * Custom trigger element. When provided it replaces the default
   * IconButton + tooltip combo, allowing callers (e.g. the sidebar) to
   * render the optimize action with their own styling. The element is
   * passed through `MenuTrigger asChild` so it must accept and forward
   * Chakra's button props.
   */
  trigger?: ReactElement;
};
const OptimizeMenu = t0 => {
  const $ = _c(13);
  const {
    isDisabled,
    onSelectPreset,
    onSelectCustom,
    trigger
  } = t0;
  let t1;
  if ($[0] !== isDisabled || $[1] !== trigger) {
    t1 = trigger ? <MenuTrigger asChild={true}>{trigger}</MenuTrigger> : <Tooltip content="Optimize"><Box display="inline-block"><MenuTrigger asChild={true}><IconButton aria-label="optimize-button" disabled={isDisabled} size="sm" variant="outline"><RiRocketLine /></IconButton></MenuTrigger></Box></Tooltip>;
    $[0] = isDisabled;
    $[1] = trigger;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onSelectPreset) {
    t2 = optimizationPresets.map(preset => <MenuItem key={preset.id} value={preset.id} onClick={() => onSelectPreset(preset.id)}>{preset.label} ({formatDuration(preset.maxMinutes + OPTIMIZATION_TIME_BUFFER_MINUTES)})</MenuItem>);
    $[3] = onSelectPreset;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onSelectCustom) {
    t3 = <MenuItem value="custom" onClick={onSelectCustom}>Custom</MenuItem>;
    $[5] = onSelectCustom;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <MenuContent>{t2}{t3}</MenuContent>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <MenuRoot>{t1}{t4}</MenuRoot>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default OptimizeMenu;